import React from "react"
import { ContainerStyled } from "./ContainerStyled"

export const Container = ({ children }) => {
  return <ContainerStyled>{children}</ContainerStyled>
}
